import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PaginationModel } from '@spartacus/core';
import { TableStructure } from '@spartacus/storefront';
import { ListService } from '@spartacus/organization/administration/components';
import { UigOrganizationTableType } from '../uig-organization.model';

@Injectable()
export abstract class UigListService<T, P = PaginationModel> extends ListService<T, P> {

    protected abstract uigTableType: UigOrganizationTableType;

    key(): string {
        return 'uid';
    }

    get uigViewType(): UigOrganizationTableType {
        return this.uigTableType;
    }

    getStructure(): Observable<TableStructure> {
        return this.tableService.buildStructure(
            this.uigViewType,
            this.defaultTableStructure
        );
    }
}
